export default function getInputColor(disabled, defaultVisible, theme) {
    let inputColor = theme.textPrimary;
    if (disabled) {
        inputColor = theme.textMuted;
    }
    else if (defaultVisible) {
        inputColor = theme.textSecondary;
    }
    return inputColor;
}
